import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-ayuda-component',
  standalone: true,
  imports: [],
  templateUrl: './title-ayuda-component.html',
  styleUrl: './title-ayuda-component.scss',
})
export class TitleAyudaComponent {
  @Input() title!: string;
}
